import { useMutation, useQueryClient } from '@tanstack/react-query';

import { AccountsApi } from '../../apis';
import { QueryKeys } from '../query-keys';

const useDeleteAccount = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (id: string) => AccountsApi.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QueryKeys.ACCOUNTS] });
    },
  });

  return {
    deleteAccount: mutation.mutateAsync,
    isDeleting: mutation.isPending,
    wasDeletedWithSuccess: mutation.isSuccess,
    wasDeletedWithoutSuccess: mutation.isError,
  };
};

export default useDeleteAccount;
